import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
      <div className="text-center px-4">
        <h1 className="font-heading font-black text-8xl md:text-9xl text-background-200 select-none">
          404
        </h1>
        <p className="mt-4 text-xl font-medium text-foreground-800">页面未找到</p>
        <p className="mt-2 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}